<script context="module" lang="ts">
    /// DEBUGGING ////////////////////
    const highlight = false;
</script>

<script lang="ts">
    import { onMount } from "svelte";
    import { wasm } from "$lib/wasm/wasm";
    import type { File } from "../wasm/file";
    import { getCanvas } from "$lib/image/preview";
    import { LOGGER } from "$lib/commands";
    import { interaction } from "$lib/state";

    export let file: File;
    export let frame: number;
    export let layer: number = -1;


    let highlightElem: HTMLElement;
    let htmlCanvas: HTMLCanvasElement;
    const canvas = getCanvas(file);

    onMount(() => {
        resize();
    });

    // Subscribe to redraw
    file.onDataChanged.onMount(([f, l]) => {
        if (f !== -1 && f !== frame) return;
        if (l !== -1 && layer !== -1 && l !== layer) return;
        draw();
    });

    async function resize() {
        if (!htmlCanvas) return;

        htmlCanvas.width = file.width;
        htmlCanvas.height = file.height;

        await draw();
    }

    $: draw(layer, frame);

    async function draw(_: any = undefined, __: any = undefined) {
        if (!htmlCanvas) return;
        // if (frame >= file.frames.value.length) return console.error("Invalid preview frame", frame);
        if (layer >= file.getLayers(frame).length) return console.error("Invalid preview layer", layer);
        // file.getFrames(); todo check this some more..

        // draw
        if (layer === -1) {
            canvas.draw_file_frame(file.internal, frame);
        } else {
            canvas.draw_file_layer(file.internal, frame, layer);
        }
        const u8_buffer = new Uint8ClampedArray(wasm.memory.buffer, canvas.data_ptr, file.width * file.height * 4);

        const result = new ImageData(
            u8_buffer,
            htmlCanvas.width,
            htmlCanvas.height,
        );

        const ctx = htmlCanvas.getContext("2d")!;
        ctx.putImageData(result, 0, 0);

        if (highlight && highlightElem) {
            highlightElem.style.animation = "none";
            highlightElem.offsetHeight;
            highlightElem.style.animation = null!;
        }
    }
</script>

<!----------------------------------------------------------------------------->

<canvas class="canvas" bind:this={htmlCanvas}>

</canvas>
{#if highlight}
    <div bind:this={highlightElem} class="highlight-updates" />
{/if}

<!----------------------------------------------------------------------------->

<style>
    canvas {
        image-rendering: pixelated;
        object-fit: contain;
        background: var(--bgcanvas);
    }

    .highlight-updates {
        position: absolute;
        inset: 0;
        outline: 4px solid transparent;
        animation: show-update 250ms;
    }

    @keyframes show-update {
        0% {
            outline-color: red;
        }
        100% {
            outline-color: transparent;
        }
    }
</style>
